import { yes } from '@silverhand/essentials';

export const isDevFeaturesEnabled =
  process.env.NODE_ENV !== 'production' || yes(process.env.DEV_FEATURES_ENABLED);

// TDA: product name, baked in at build time. Replaces the leading `TDxIdentity` of the
// `tdx_product_name` phrase, so per-tenant qualifiers such as "Console" keep working.
export const productName = process.env.TDX_PRODUCT_NAME?.trim() || 'iGrovi';
